<template>
    <div>
        <!--Variant Detail View-->

        <router-link :to="`/show-id-variants/${route.params.id}`" >Back to Variant List</router-link>
        
    </div>
</template>

<script setup lang="js">
import { useRoute } from 'vue-router';

const route = useRoute();

</script>